// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OT7l","importantInfo":"styles_importantInfo__1BLwj"};